import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = {
  key: 0,
  class: "flex-center py-10"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-danger mb-4"
}
const _hoisted_4 = {
  key: 2,
  class: "souscription-block widget bg-gradient-dark px-6 pt-8 pb-6 mb-5"
}
const _hoisted_5 = { class: "souscription-grid" }
const _hoisted_6 = { class: "souscription-identity" }
const _hoisted_7 = { class: "souscription-avatar" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "souscription-identity-body" }
const _hoisted_10 = { class: "mb-1" }
const _hoisted_11 = { class: "font-normal text-grey-200 mb-3" }
const _hoisted_12 = { class: "mb-1" }
const _hoisted_13 = { class: "souscription-email mb-3" }
const _hoisted_14 = {
  key: 0,
  class: "text-sm text-grey-300 mb-1"
}
const _hoisted_15 = {
  key: 1,
  class: "font-semibold mb-3"
}
const _hoisted_16 = {
  key: 2,
  class: "tag-state notif stroke"
}
const _hoisted_17 = {
  key: 3,
  class: "tag-state danger stroke"
}
const _hoisted_18 = { class: "souscription-dates" }
const _hoisted_19 = { class: "font-semibold" }
const _hoisted_20 = { class: "font-semibold" }
const _hoisted_21 = { class: "font-semibold" }
const _hoisted_22 = { class: "font-semibold" }
const _hoisted_23 = { class: "font-semibold" }
const _hoisted_24 = { class: "souscription-widgets" }
const _hoisted_25 = { class: "souscription-widgets-grid" }
const _hoisted_26 = { class: "souscription-card" }
const _hoisted_27 = { class: "souscription-card-value" }
const _hoisted_28 = { class: "souscription-card" }
const _hoisted_29 = { class: "souscription-card-value" }
const _hoisted_30 = { class: "souscription-card-extra" }
const _hoisted_31 = { class: "souscription-card" }
const _hoisted_32 = { class: "souscription-card-value" }
const _hoisted_33 = { class: "souscription-card" }
const _hoisted_34 = { class: "souscription-card-value" }
const _hoisted_35 = { class: "souscription-card-extra" }
const _hoisted_36 = { class: "souscription-progress mt-6" }
const _hoisted_37 = { class: "souscription-progress-header mb-2" }
const _hoisted_38 = { class: "text-sm text-grey-200" }
const _hoisted_39 = { class: "souscription-progress-bar" }
const _hoisted_40 = {
  key: 3,
  class: "clear-both h-5"
}
const _hoisted_41 = {
  key: 4,
  class: "step vertical bg-grey-500 ml-auto mr-auto"
}
const _hoisted_42 = {
  key: 5,
  class: "clear-both h-5"
}
const _hoisted_43 = {
  key: 6,
  class: "s20 widget px-6 pt-8 pb-2 mb-5"
}
const _hoisted_44 = { class: "s10 mt--5-5 flex-right gap-3" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { class: "s20 items-center gap-6 px-5 pb-6 collapse-content-flex active" }
const _hoisted_48 = { class: "s7_mobile pt-5" }
const _hoisted_49 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_50 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_51 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_52 = {
  key: 2,
  class: "tag-state warning stroke"
}
const _hoisted_53 = { class: "s6 rounded-50 overflow-hidden item" }
const _hoisted_54 = ["src"]
const _hoisted_55 = { class: "s14 mt-5 px-5" }
const _hoisted_56 = {
  key: 0,
  class: "text-grey-900 mb-3"
}
const _hoisted_57 = {
  key: 1,
  class: "text-grey-900 mb-3"
}
const _hoisted_58 = {
  key: 2,
  class: "font-normal my-1 text-grey-800"
}
const _hoisted_59 = {
  key: 3,
  class: "font-normal my-1 text-grey-800"
}
const _hoisted_60 = { class: "text-grey-900 mt-4" }
const _hoisted_61 = { class: "s6_mobile px-6" }
const _hoisted_62 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_63 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_64 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_65 = {
  key: 2,
  class: "tag-state warning stroke"
}
const _hoisted_66 = {
  key: 0,
  class: "text-grey-900 my-2"
}
const _hoisted_67 = {
  key: 1,
  class: "text-grey-900 my-2"
}
const _hoisted_68 = {
  key: 2,
  class: "text-grey-900 my-2"
}
const _hoisted_69 = {
  key: 3,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_70 = {
  key: 4,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_71 = {
  key: 5,
  class: "flex gap-4"
}
const _hoisted_72 = ["src"]
const _hoisted_73 = ["src"]
const _hoisted_74 = {
  key: 6,
  class: "flex gap-4"
}
const _hoisted_75 = ["src"]
const _hoisted_76 = {
  key: 7,
  class: "flex gap-4"
}
const _hoisted_77 = { class: "s7_mobile px-6" }
const _hoisted_78 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_79 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_80 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_81 = {
  key: 2,
  class: "tag-state warning stroke"
}
const _hoisted_82 = ["href"]
const _hoisted_83 = { class: "font-normal mb-2 text-grey-800" }
const _hoisted_84 = { class: "text-grey-500" }
const _hoisted_85 = { class: "mb-5 text-grey-800" }
const _hoisted_86 = ["href"]
const _hoisted_87 = { class: "font-normal mb-2 text-grey-800" }
const _hoisted_88 = { class: "text-grey-500" }
const _hoisted_89 = { class: "mb-5 text-grey-800" }
const _hoisted_90 = ["href"]
const _hoisted_91 = { class: "font-normal mb-2 text-grey-800" }
const _hoisted_92 = { class: "text-grey-500" }
const _hoisted_93 = { class: "mb-5 text-grey-800" }
const _hoisted_94 = {
  key: 1,
  class: "text-grey-500"
}
const _hoisted_95 = {
  key: 7,
  class: "clear-both h-5"
}
const _hoisted_96 = {
  key: 8,
  class: "step vertical bg-grey-500 ml-auto mr-auto"
}
const _hoisted_97 = {
  key: 9,
  class: "clear-both h-5"
}
const _hoisted_98 = {
  key: 10,
  class: "s20 widget px-6 pt-8 pb-2 mb-5"
}
const _hoisted_99 = { class: "s20 items-center gap-6 px-5 pb-6 collapse-content-flex active" }
const _hoisted_100 = { class: "s7_mobile pt-5" }
const _hoisted_101 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_102 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_103 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_104 = {
  key: 0,
  class: "text-grey-900"
}
const _hoisted_105 = {
  key: 1,
  class: "text-grey-900"
}
const _hoisted_106 = {
  key: 2,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_107 = {
  key: 3,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_108 = {
  key: 4,
  class: "font-semibold my-2 text-grey-800"
}
const _hoisted_109 = {
  key: 5,
  class: "font-semibold my-2 text-grey-800"
}
const _hoisted_110 = {
  key: 6,
  class: "mb-2 text-grey-800"
}
const _hoisted_111 = {
  key: 7,
  class: "mb-2 text-grey-800"
}
const _hoisted_112 = {
  key: 8,
  class: "tag-state notif stroke"
}
const _hoisted_113 = {
  key: 9,
  class: "tag-state danger stroke"
}
const _hoisted_114 = { class: "s7_mobile px-6" }
const _hoisted_115 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_116 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_117 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_118 = { class: "text-grey-900 my-2" }
const _hoisted_119 = {
  key: 0,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_120 = {
  key: 1,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_121 = {
  key: 2,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_122 = {
  key: 3,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_123 = { class: "s6_mobile px-6" }
const _hoisted_124 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_125 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_126 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_127 = { class: "text-grey-900 my-2" }
const _hoisted_128 = { class: "text-grey-900 my-2" }
const _hoisted_129 = {
  key: 0,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_130 = {
  key: 1,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_131 = {
  key: 2,
  class: "mb-2 text-grey-800"
}
const _hoisted_132 = {
  key: 3,
  class: "mb-2 text-grey-800"
}
const _hoisted_133 = {
  key: 11,
  class: "clear-both h-5"
}
const _hoisted_134 = {
  key: 12,
  class: "step vertical bg-grey-500 ml-auto mr-auto"
}
const _hoisted_135 = {
  key: 13,
  class: "clear-both h-5"
}
const _hoisted_136 = {
  key: 14,
  class: "s20 widget px-6 pt-8 pb-2 mb-5"
}
const _hoisted_137 = { class: "s20 items-center gap-6 px-5 pb-6 collapse-content-flex active" }
const _hoisted_138 = { class: "s7_mobile pt-6" }
const _hoisted_139 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_140 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_141 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_142 = {
  key: 0,
  class: "text-grey-900"
}
const _hoisted_143 = {
  key: 1,
  class: "text-grey-900"
}
const _hoisted_144 = {
  key: 2,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_145 = {
  key: 3,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_146 = {
  key: 4,
  class: "mb-2 text-grey-800"
}
const _hoisted_147 = {
  key: 5,
  class: "mb-2 text-grey-800"
}
const _hoisted_148 = { class: "s7_mobile px-6" }
const _hoisted_149 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_150 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_151 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_152 = {
  key: 0,
  class: "text-grey-900 my-2"
}
const _hoisted_153 = {
  key: 1,
  class: "text-grey-900 my-2"
}
const _hoisted_154 = { class: "text-grey-900 my-2" }
const _hoisted_155 = {
  key: 2,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_156 = {
  key: 3,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_157 = {
  key: 4,
  class: "text-grey-800"
}
const _hoisted_158 = {
  key: 5,
  class: "text-grey-800"
}
const _hoisted_159 = {
  key: 6,
  class: "mb-2 text-grey-800"
}
const _hoisted_160 = {
  key: 7,
  class: "mb-2 text-grey-800"
}
const _hoisted_161 = { class: "s6_mobile px-6" }
const _hoisted_162 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_163 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_164 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_165 = {
  key: 0,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_166 = {
  key: 1,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_167 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_168 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_169 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_170 = {
  key: 2,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_171 = {
  key: 3,
  class: "font-normal my-2 text-grey-500"
}
const _hoisted_172 = {
  key: 15,
  class: "clear-both h-5"
}
const _hoisted_173 = {
  key: 16,
  class: "step vertical bg-grey-500 ml-auto mr-auto"
}
const _hoisted_174 = {
  key: 17,
  class: "clear-both h-5"
}
const _hoisted_175 = {
  key: 18,
  class: "s20 widget px-6 pt-8 pb-2"
}
const _hoisted_176 = { class: "s20 items-center gap-6 pb-4 collapse-content active" }
const _hoisted_177 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_178 = { class: "widget-floating py-0 text-xl flex-right" }
const _hoisted_179 = { class: "font-medium" }
const _hoisted_180 = {
  key: 0,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_181 = {
  key: 1,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_182 = {
  key: 2,
  class: "px-1",
  style: {"display":"grid","grid-template-columns":"repeat(auto-fill, minmax(220px, 1fr))","gap":"1rem"}
}
const _hoisted_183 = { class: "s10" }
const _hoisted_184 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_185 = {
  class: "secondary-font font-semibold text-grey-900 py-1",
  style: {"white-space":"nowrap"}
}
const _hoisted_186 = { class: "s10 text-right" }
const _hoisted_187 = {
  key: 0,
  class: "secondary-font font-semibold text-grey-600 pb-2"
}
const _hoisted_188 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_189 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_190 = {
  key: 3,
  class: "secondary-font font-semibold text-grey-600 pt-1 mb-4"
}
const _hoisted_191 = ["disabled", "onClick"]
const _hoisted_192 = {
  key: 19,
  class: "clear-both h-5"
}
const _hoisted_193 = {
  key: 20,
  class: "step vertical bg-grey-500 ml-auto mr-auto"
}
const _hoisted_194 = {
  key: 21,
  class: "clear-both h-5"
}
const _hoisted_195 = {
  key: 22,
  class: "s20 widget px-6 pt-8 pb-2"
}
const _hoisted_196 = { class: "s20 items-center gap-6 px-5 pb-4 collapse-content active" }
const _hoisted_197 = { class: "flex items-center gap-6" }
const _hoisted_198 = { class: "s7" }
const _hoisted_199 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_200 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_201 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_202 = { class: "s7" }
const _hoisted_203 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_204 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_205 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_206 = { class: "s6" }
const _hoisted_207 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_208 = {
  key: 0,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_209 = {
  key: 1,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_210 = {
  key: 2,
  class: "px-1",
  style: {"display":"grid","grid-template-columns":"repeat(auto-fill, minmax(220px, 1fr))","gap":"1rem"}
}
const _hoisted_211 = { class: "s10" }
const _hoisted_212 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_213 = {
  class: "secondary-font font-semibold text-grey-900 py-1",
  style: {"white-space":"nowrap"}
}
const _hoisted_214 = { class: "secondary-font font-semibold text-purple" }
const _hoisted_215 = { class: "s10 text-right" }
const _hoisted_216 = {
  key: 0,
  class: "secondary-font font-semibold text-primary-color pb-1"
}
const _hoisted_217 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_218 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_219 = {
  key: 3,
  class: "secondary-font font-semibold text-grey-600 pt-1"
}
const _hoisted_220 = {
  key: 4,
  class: "secondary-font font-semibold text-grey-600 py-1"
}
const _hoisted_221 = {
  key: 23,
  class: "clear-both h-5"
}
const _hoisted_222 = {
  key: 24,
  class: "step vertical bg-grey-500 ml-auto mr-auto"
}
const _hoisted_223 = {
  key: 25,
  class: "clear-both h-5"
}
const _hoisted_224 = {
  key: 26,
  class: "s20 widget px-6 pt-8 pb-2"
}
const _hoisted_225 = { class: "s20 gap-6 px-5 pb-8 collapse-content active" }
const _hoisted_226 = {
  key: 0,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_227 = {
  key: 1,
  class: "flex items-center gap-6"
}
const _hoisted_228 = { class: "s7" }
const _hoisted_229 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_230 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_231 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_232 = { class: "s7" }
const _hoisted_233 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_234 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_235 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_236 = { class: "s6" }
const _hoisted_237 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_238 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_239 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}

import { ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'
import moment from 'moment'
import membersService from '@/services/membersService'
import { showAlert, showConfirm } from '@/utils/swal'

interface PrelevementMensuel {
  id: number
  souscription_id: number
  mois: number
  date_prevision: string | null
  date_operation: string | null
  montant: number
  statut: 'pending' | 'done' | 'cancelled'
  countdown: string | null
}

interface DecaissementMensuel {
  id: number
  mois: number
  date_prevision: string | null
  date_operation: string | null
  montant: number
  percent: number
  statut: 'pending' | 'done' | 'cancelled'
  countdown: string | null
}

interface Member {
  id: number
  nom: string
  prenom: string
  collectivite?: {
    id: number
    nom: string
  }
  photo?: string
  photo_url?: string
  email?: string
  telephone?: string
  created_at?: string
  last_connection_at?: string
  actif?: number
  deleted_at?: string | null
  date_engagement?: string | null
  date_naissance?: string | null
  fonction?: string | null
  salaire?: number | null
  balance?: number | null
  quotite_cessible_pourcent?: number | null
  quotite_cessible_montant?: number | null
  souscription_id?: number | null
  souscription?: any
  kyc?: any
  cartes?: any[]
  numero_piece_identite?: string | null
  type_piece_identite?: string | null
  bulletin1_document?: any
  bulletin2_document?: any
  bulletin3_document?: any
  document_identite_recto?: any
  document_identite_verso?: any
  email_verified_at?: string | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectiviteMembreDetail',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const member = ref<Member | null>(null)
const loading = ref(false)
const errorMessage = ref('')

const prelevementsMensuels = ref<PrelevementMensuel[]>([])
const prelevementsStats = ref({ total_attendu: 0, total_effectue: 0, percent: 0 })
const prelevementsLoading = ref(false)
const validatingPrelevementId = ref<number | null>(null)

const decaissementsMensuels = ref<DecaissementMensuel[]>([])
const decaissementsStats = ref({
  debloque: 0,
  debloque_percent: 0,
  bloque: 0,
  bloque_percent: 0,
  total: 0,
})
const decaissementsLoading = ref(false)

const walletInfos = ref({
  solde: 0,
  solde_percent: 0,
  utilise: 0,
  utilise_percent: 0,
  dernier_decaissement: 0,
  dernier_decaissement_percent: 0,
  dernier_decaissement_date: null as string | null,
})
const walletLoading = ref(false)

const cartes = ref<Array<{ id: number; statut: string }>>([])
const hasCarteEnAttenteRetrait = computed(() => cartes.value.some(c => c.statut === 'delivery'))

const kycActionLoading = ref(false)
const kycStatut = computed(() => member.value?.kyc?.statut)

const progressWidth = computed(() => Math.min(prelevementsStats.value.percent, 100))

const quotiteUsedPercent = computed(() => {
  const m = member.value
  if (!m?.quotite_cessible_montant || !m.salaire || m.salaire <= 0) return 0
  return 0
})

function formatAmount(amount: number | null | undefined): string {
  return new Intl.NumberFormat('fr-FR').format(amount || 0)
}

function formatDate(date: string | null | undefined, format = 'DD/MM/YYYY'): string {
  if (!date) return '-'
  const m = moment(date)
  if (!m.isValid()) return '-'
  return m.format(format)
}

function formatDateFrench(dateString: string | null | undefined): string {
  if (!dateString) return '-'
  const monthsFr = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
  const date = moment(dateString)
  if (!date.isValid()) return '-'
  return `${date.date()} ${monthsFr[date.month()]} ${date.year()}`
}

function calculateAnciennete(dateEngagement: string | null | undefined): string {
  if (!dateEngagement) return '-'
  const engagementDate = moment(dateEngagement)
  if (!engagementDate.isValid()) return '-'
  const now = moment()
  const years = now.diff(engagementDate, 'years')
  const months = now.diff(engagementDate, 'months') % 12
  if (years > 0 && months > 0) return `${years} an${years > 1 ? 's' : ''} ${months} mois`
  if (years > 0) return `${years} an${years > 1 ? 's' : ''}`
  if (months > 0) return `${months} mois`
  return '0 mois'
}

async function validateKyc() {
  if (!member.value?.kyc) {
    await showAlert.warning('Aucun KYC à valider pour ce membre.', 'Information')
    return
  }
  const ok = await showConfirm('Confirmer la validation du KYC de ce membre ?', 'Validation KYC')
  if (!ok) return
  kycActionLoading.value = true
  try {
    await axios.post(`/kyc/members/${route.params.id}/validate`)
    await loadMember(member.value.id)
    await showAlert.success('KYC validé.', 'Succès')
  } catch (e: any) {
    await showAlert.error(e.response?.data?.message || 'Erreur lors de la validation.', 'Erreur')
  } finally {
    kycActionLoading.value = false
  }
}

async function rejectKyc() {
  if (!member.value?.kyc) {
    await showAlert.warning('Aucun KYC à rejeter pour ce membre.', 'Information')
    return
  }
  const ok = await showConfirm('Confirmer le rejet du KYC de ce membre ?', 'Rejet KYC')
  if (!ok) return
  kycActionLoading.value = true
  try {
    await axios.post(`/kyc/members/${route.params.id}/reject`)
    await loadMember(member.value.id)
    await showAlert.success('KYC rejeté.', 'Succès')
  } catch (e: any) {
    await showAlert.error(e.response?.data?.message || 'Erreur lors du rejet.', 'Erreur')
  } finally {
    kycActionLoading.value = false
  }
}

function goToKyc() {
  if (member.value) {
    router.push({ name: 'collectivites-kyc-membre-detail', params: { id: member.value.id } })
  }
}

onMounted(async () => {
  const memberId = route.params.id
  if (memberId) {
    await loadMember(Number(memberId))
    await loadPrelevementsMensuels(Number(memberId))
    await loadDecaissementsMensuels(Number(memberId))
    await loadWalletInfos(Number(memberId))
    await loadCartes(Number(memberId))
  } else {
    router.push({ name: 'collectivites-membres' })
  }
})

async function loadPrelevementsMensuels(id: number) {
  prelevementsLoading.value = true
  try {
    const data = await membersService.getMemberPrelevementsMensuels(id)
    prelevementsMensuels.value = data.items || []
    prelevementsStats.value = data.stats || { total_attendu: 0, total_effectue: 0, percent: 0 }
  } catch (error: any) {
    console.error('Erreur chargement prélèvements mensuels:', error)
  } finally {
    prelevementsLoading.value = false
  }
}

async function loadDecaissementsMensuels(id: number) {
  decaissementsLoading.value = true
  try {
    const data = await membersService.getMemberDecaissementsMensuels(id)
    decaissementsMensuels.value = data.items || []
    decaissementsStats.value = data.stats || {
      debloque: 0, debloque_percent: 0,
      bloque: 0, bloque_percent: 0,
      total: 0,
    }
  } catch (error: any) {
    console.error('Erreur chargement décaissements mensuels:', error)
  } finally {
    decaissementsLoading.value = false
  }
}

async function loadWalletInfos(id: number) {
  walletLoading.value = true
  try {
    const data = await membersService.getMemberWalletInfos(id)
    walletInfos.value = data || walletInfos.value
  } catch (error: any) {
    console.error('Erreur chargement wallet infos:', error)
  } finally {
    walletLoading.value = false
  }
}

async function loadCartes(id: number) {
  try {
    const data = await membersService.getMemberCartes(id)
    cartes.value = data.cartes || []
  } catch (error: any) {
    console.error('Erreur chargement cartes:', error)
  }
}

async function validatePrelevementMensuel(detail: PrelevementMensuel) {
  if (!member.value) return
  if (validatingPrelevementId.value !== null) return

  const confirmation = await showConfirm(
    `Valider le prélèvement de ${formatAmount(detail.montant)} F pour ${formatPrelevementDateLong(detail.date_prevision)} ?`,
    'Confirmation de validation'
  )
  if (!confirmation) return

  validatingPrelevementId.value = detail.id
  try {
    await membersService.validateMemberPrelevementMensuel(member.value.id, detail.id)
    await loadPrelevementsMensuels(member.value.id)
    await showAlert.success('Prélèvement validé avec succès.', 'Validation réussie')
  } catch (error: any) {
    await showAlert.error(error.message || 'Erreur lors de la validation.', 'Erreur')
  } finally {
    validatingPrelevementId.value = null
  }
}

function formatPrelevementDate(dateString: string | null): string {
  if (!dateString) return '-'
  const monthsFr = ['Jan', 'Fév', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc']
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return '-'
  return `${String(date.getDate()).padStart(2, '0')} ${monthsFr[date.getMonth()]} ${date.getFullYear()}`
}

function formatPrelevementDateLong(dateString: string | null): string {
  if (!dateString) return '-'
  const monthsFr = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return '-'
  return `${String(date.getDate()).padStart(2, '0')} ${monthsFr[date.getMonth()]} ${date.getFullYear()}`
}

async function loadMember(id: number) {
  try {
    loading.value = true
    errorMessage.value = ''
    const data = await membersService.getMember(id)
    member.value = data
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors du chargement du membre'
    // Rediriger vers la liste si le membre n'est pas trouvé
    setTimeout(() => {
      router.push({ name: 'collectivites-membres' })
    }, 2000)
  } finally {
    loading.value = false
  }
}

function goBack() {
  router.push({ name: 'collectivites-membres' })
}

function goToCarte() {
  if (member.value) {
    router.push({ name: 'collectivites-membre-carte', params: { id: member.value.id } })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", { class: "d-flex align-items-center gap-4 mb-6" }, [
      _createElementVNode("button", {
        class: "btn white2",
        onClick: goBack
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("img", {
          src: "/public/icons/icon-back.svg",
          class: "btn-icon",
          alt: ""
        }, null, -1),
        _createElementVNode("span", null, "Retour", -1)
      ]))]),
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-0" }, "Membres - Détail du membre", -1))
    ]),
    _cache[96] || (_cache[96] = _createElementVNode("div", { class: "clear-both h-0" }, null, -1)),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "loader dark" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "souscription-title" }, [
            _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-panel-open.svg",
                class: "size-xs icon-neutral mr-2",
                alt: ""
              }),
              _createTextVNode(" Souscription ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: member.value.photo_url ? member.value.photo_url : '/public/assets/users/300w/user2.jpg',
                  alt: ""
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h3", _hoisted_10, _toDisplayString(member.value.nom) + " " + _toDisplayString(member.value.prenom), 1),
                _createElementVNode("h5", _hoisted_11, _toDisplayString(member.value.collectivite?.nom || 'N/A'), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(member.value.telephone || '-'), 1),
                _createElementVNode("p", _hoisted_13, _toDisplayString(member.value.email || '-'), 1),
                (member.value.date_engagement)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Date d'engagement"))
                  : _createCommentVNode("", true),
                (member.value.date_engagement)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(formatDateFrench(member.value.date_engagement)) + " · " + _toDisplayString(calculateAnciennete(member.value.date_engagement)), 1))
                  : _createCommentVNode("", true),
                (member.value.actif)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Actif"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_17, "Inactif"))
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", null, [
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-sm text-grey-300 mb-1" }, "Date de souscription", -1)),
                _createElementVNode("p", _hoisted_19, _toDisplayString(member.value.created_at ? formatDateFrench(member.value.created_at) : '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-sm text-grey-300 mb-1" }, "Date de fin de souscription", -1)),
                _createElementVNode("p", _hoisted_20, _toDisplayString(member.value.souscription?.date_fin ? formatDateFrench(member.value.souscription.date_fin) : '-'), 1)
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "souscription-hr" }, null, -1)),
              _createElementVNode("div", null, [
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-sm text-grey-300 mb-1" }, "Utilisation total", -1)),
                _createElementVNode("p", _hoisted_21, _toDisplayString(member.value.balance ? formatAmount(member.value.balance) + ' F' : '0 F'), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm text-grey-300 mb-1" }, "Salaire Net après utilisation", -1)),
                _createElementVNode("p", _hoisted_22, _toDisplayString(member.value.salaire ? formatAmount((member.value.salaire || 0) - (member.value.balance || 0)) + ' F' : '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-sm text-grey-300 mb-1" }, "Quotité cessible disponible", -1)),
                _createElementVNode("p", _hoisted_23, _toDisplayString(member.value.quotite_cessible_pourcent && member.value.quotite_cessible_montant
                ? `${member.value.quotite_cessible_pourcent}% · ${formatAmount(member.value.quotite_cessible_montant)} F`
                : '-'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _cache[9] || (_cache[9] = _createElementVNode("p", { class: "souscription-card-label" }, "Salaire Net", -1)),
                  _createElementVNode("p", _hoisted_27, _toDisplayString(member.value.salaire ? formatAmount(member.value.salaire) + ' F' : '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _cache[10] || (_cache[10] = _createElementVNode("p", { class: "souscription-card-label" }, "Prélèvement sur salaire", -1)),
                  _createElementVNode("p", _hoisted_29, _toDisplayString(member.value.quotite_cessible_montant ? formatAmount(member.value.quotite_cessible_montant) + ' F' : '-'), 1),
                  _createElementVNode("p", _hoisted_30, _toDisplayString(member.value.quotite_cessible_pourcent ? member.value.quotite_cessible_pourcent + '%' : ''), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _cache[11] || (_cache[11] = _createElementVNode("p", { class: "souscription-card-label" }, "Mon revolving", -1)),
                  _createElementVNode("p", _hoisted_32, _toDisplayString(member.value.balance ? formatAmount(member.value.balance) + ' F' : '-'), 1),
                  _cache[12] || (_cache[12] = _createElementVNode("p", { class: "souscription-card-extra" }, "Par mois", -1))
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[13] || (_cache[13] = _createElementVNode("p", { class: "souscription-card-label" }, "Pouvoir d'achat", -1)),
                  _createElementVNode("p", _hoisted_34, _toDisplayString(member.value.souscription?.montant ? formatAmount(member.value.souscription.montant) + ' F' : '-'), 1),
                  _createElementVNode("p", _hoisted_35, _toDisplayString(member.value.souscription?.duree_mois ? member.value.souscription.duree_mois + ' mois' : ''), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "font-semibold text-grey-100" }, "Utilisation", -1)),
                  _createElementVNode("span", _hoisted_38, _toDisplayString(quotiteUsedPercent.value) + "%", 1)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", {
                    class: "souscription-progress-fill bg-pop-green",
                    style: _normalizeStyle(`width: ${Math.max(quotiteUsedPercent.value, 2)}%;`)
                  }, null, 4)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5 collapse-open-flex active" }, [
            _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-panel-open.svg",
                class: "size-xs icon-neutral mr-2 collapse-icon-open",
                alt: ""
              }),
              _createElementVNode("img", {
                src: "/public/icons/icon-panel-close.svg",
                class: "size-xs icon-neutral mr-2 collapse-icon-close",
                alt: ""
              }),
              _createTextVNode(" Identification / Bulletin ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("button", {
              class: "btn-ultra",
              style: {"color":"var(--color-white) !important"},
              onClick: goToKyc
            }, [...(_cache[16] || (_cache[16] = [
              _createElementVNode("div", { class: "btn-show" }, [
                _createElementVNode("img", {
                  src: "/public/icons/icon-edit.svg",
                  class: "btn-icon icon-white",
                  alt: ""
                }),
                _createElementVNode("span", { style: {"color":"var(--color-white)"} }, "Editer")
              ], -1)
            ]))]),
            _createElementVNode("button", {
              class: "btn-ultra danger",
              disabled: kycActionLoading.value || !member.value.kyc || kycStatut.value === 'rejected',
              onClick: rejectKyc
            }, [...(_cache[17] || (_cache[17] = [
              _createElementVNode("div", { class: "btn-show" }, [
                _createElementVNode("img", {
                  src: "/public/icons/icon-denied.svg",
                  class: "btn-icon icon-white",
                  alt: ""
                }),
                _createElementVNode("span", { style: {"color":"var(--color-white)"} }, "Rejeter")
              ], -1)
            ]))], 8, _hoisted_45),
            _createElementVNode("button", {
              class: "btn-ultra",
              disabled: kycActionLoading.value || !member.value.kyc || kycStatut.value === 'verified',
              onClick: validateKyc
            }, [...(_cache[18] || (_cache[18] = [
              _createElementVNode("div", { class: "btn-show" }, [
                _createElementVNode("img", {
                  src: "/public/icons/icon-valider.svg",
                  class: "btn-icon icon-neutral",
                  alt: ""
                }),
                _createElementVNode("span", null, "Valider")
              ], -1)
            ]))], 8, _hoisted_46)
          ]),
          _cache[34] || (_cache[34] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("h3", _hoisted_49, [
                _cache[19] || (_cache[19] = _createTextVNode(" Identification   ", -1)),
                (kycStatut.value === 'verified')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Validé"))
                  : (kycStatut.value === 'rejected')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, "Rejeté"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_52, "En attente"))
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("img", {
                  src: member.value.photo_url ? member.value.photo_url : '/public/assets/users/300w/user2.jpg',
                  width: "100%"
                }, null, 8, _hoisted_54)
              ]),
              _createElementVNode("div", _hoisted_55, [
                (member.value.kyc?.id)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_56, "n° CF" + _toDisplayString(member.value.created_at ? _unref(moment)(member.value.created_at).format('YYYY') : '2025') + "-" + _toDisplayString(String(member.value.kyc.id).padStart(6, '0')), 1))
                  : (_openBlock(), _createElementBlock("h4", _hoisted_57, "n° -")),
                (member.value.kyc?.created_at)
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_58, "Effectuée le"))
                  : _createCommentVNode("", true),
                (member.value.kyc?.created_at)
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_59, _toDisplayString(formatDate(member.value.kyc.created_at, 'DD/MM/YYYY HH:mm')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("h5", _hoisted_60, _toDisplayString(member.value.nom) + " " + _toDisplayString(member.value.prenom), 1)
              ])
            ]),
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "flex-center" }, [
              _createElementVNode("hr", { class: "hr-vertical h-100p" })
            ], -1)),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("h3", _hoisted_62, [
                _cache[20] || (_cache[20] = _createTextVNode(" Pièce d'identité   ", -1)),
                (kycStatut.value === 'verified')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_63, "Validé"))
                  : (kycStatut.value === 'rejected')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_64, "Rejeté"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_65, "En attente"))
              ]),
              (member.value.numero_piece_identite)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_66, "N° " + _toDisplayString(member.value.numero_piece_identite) + " / " + _toDisplayString(member.value.type_piece_identite || 'CNI'), 1))
                : (member.value.kyc?.piece_numero)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_67, "N° " + _toDisplayString(member.value.kyc.piece_numero) + " / " + _toDisplayString(member.value.kyc?.piece_type || 'CNI'), 1))
                  : (_openBlock(), _createElementBlock("h4", _hoisted_68, "N° - / -")),
              (member.value.kyc?.piece_expiration)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_69, [
                    _cache[21] || (_cache[21] = _createTextVNode(" Date d'expiration ", -1)),
                    _createElementVNode("b", null, _toDisplayString(formatDateFrench(member.value.kyc.piece_expiration)), 1)
                  ]))
                : (_openBlock(), _createElementBlock("h6", _hoisted_70, [...(_cache[22] || (_cache[22] = [
                    _createTextVNode("Date d'expiration ", -1),
                    _createElementVNode("b", null, "-", -1)
                  ]))])),
              (member.value.document_identite_recto || member.value.document_identite_verso)
                ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                    (member.value.document_identite_recto)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: member.value.document_identite_recto.fichier_url,
                          width: "100%"
                        }, null, 8, _hoisted_72))
                      : _createCommentVNode("", true),
                    (member.value.document_identite_verso)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: member.value.document_identite_verso.fichier_url,
                          width: "100%"
                        }, null, 8, _hoisted_73))
                      : _createCommentVNode("", true)
                  ]))
                : (member.value.kyc && member.value.kyc.kyc_documents && member.value.kyc.kyc_documents.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.value.kyc.kyc_documents.slice(0, 2), (doc, idx) => {
                        return (_openBlock(), _createElementBlock("img", {
                          key: idx,
                          src: doc.fichier_url,
                          width: "100%"
                        }, null, 8, _hoisted_75))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_76, [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("div", { class: "text-grey-500" }, "Aucun document disponible", -1)
                    ]))]))
            ]),
            _cache[32] || (_cache[32] = _createElementVNode("div", { class: "flex-center" }, [
              _createElementVNode("hr", { class: "hr-vertical h-100p" })
            ], -1)),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("h3", _hoisted_78, [
                _cache[24] || (_cache[24] = _createTextVNode(" Bulletins de salaires   ", -1)),
                (kycStatut.value === 'verified')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_79, "Validé"))
                  : (kycStatut.value === 'rejected')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_80, "Rejeté"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_81, "En attente"))
              ]),
              (member.value.bulletin1_document || member.value.bulletin2_document || member.value.bulletin3_document)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (member.value.bulletin1_document)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: member.value.bulletin1_document.fichier_url,
                          target: "_blank"
                        }, [
                          _createElementVNode("h5", _hoisted_83, [
                            _cache[25] || (_cache[25] = _createTextVNode("Bulletin 1 - ", -1)),
                            _createElementVNode("span", _hoisted_84, _toDisplayString(formatDateFrench(member.value.bulletin1_document.created_at)), 1)
                          ]),
                          _createElementVNode("h5", _hoisted_85, [
                            _cache[26] || (_cache[26] = _createElementVNode("img", {
                              src: "/public/icons/icon-download.svg",
                              class: "size-sm mr-2",
                              alt: ""
                            }, null, -1)),
                            _createTextVNode(_toDisplayString(member.value.bulletin1_document.fichier || 'fichier_bulletin.pdf'), 1)
                          ])
                        ], 8, _hoisted_82))
                      : _createCommentVNode("", true),
                    (member.value.bulletin2_document)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: member.value.bulletin2_document.fichier_url,
                          target: "_blank"
                        }, [
                          _createElementVNode("h5", _hoisted_87, [
                            _cache[27] || (_cache[27] = _createTextVNode("Bulletin 2 - ", -1)),
                            _createElementVNode("span", _hoisted_88, _toDisplayString(formatDateFrench(member.value.bulletin2_document.created_at)), 1)
                          ]),
                          _createElementVNode("h5", _hoisted_89, [
                            _cache[28] || (_cache[28] = _createElementVNode("img", {
                              src: "/public/icons/icon-download.svg",
                              class: "size-sm mr-2",
                              alt: ""
                            }, null, -1)),
                            _createTextVNode(_toDisplayString(member.value.bulletin2_document.fichier || 'fichier_bulletin.pdf'), 1)
                          ])
                        ], 8, _hoisted_86))
                      : _createCommentVNode("", true),
                    (member.value.bulletin3_document)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          href: member.value.bulletin3_document.fichier_url,
                          target: "_blank"
                        }, [
                          _createElementVNode("h5", _hoisted_91, [
                            _cache[29] || (_cache[29] = _createTextVNode("Bulletin 3 - ", -1)),
                            _createElementVNode("span", _hoisted_92, _toDisplayString(formatDateFrench(member.value.bulletin3_document.created_at)), 1)
                          ]),
                          _createElementVNode("h5", _hoisted_93, [
                            _cache[30] || (_cache[30] = _createElementVNode("img", {
                              src: "/public/icons/icon-download.svg",
                              class: "size-sm mr-2",
                              alt: ""
                            }, null, -1)),
                            _createTextVNode(_toDisplayString(member.value.bulletin3_document.fichier || 'fichier_bulletin.pdf'), 1)
                          ])
                        ], 8, _hoisted_90))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("p", _hoisted_94, "Aucun bulletin disponible"))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_95))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_96))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_97))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
          _cache[53] || (_cache[53] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open-flex active\" data-v-2a9c92f7><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\" data-v-2a9c92f7><img src=\"/public/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\" data-v-2a9c92f7><img src=\"/public/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\" data-v-2a9c92f7> Contrat d&#39;engagement </span></div><div class=\"clear-both h-5\" data-v-2a9c92f7></div>", 2)),
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("h3", _hoisted_101, [
                _cache[35] || (_cache[35] = _createTextVNode(" Coop Finance   ", -1)),
                (member.value.souscription_id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_102, "Validé"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_103, "En attente"))
              ]),
              (member.value.souscription_id)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_104, "Contrat n° / CF" + _toDisplayString(member.value.created_at ? _unref(moment)(member.value.created_at).format('YYYY') : '2025') + "-" + _toDisplayString(String(member.value.souscription_id).padStart(6, '0')), 1))
                : (_openBlock(), _createElementBlock("h4", _hoisted_105, "Contrat n° / -")),
              (member.value.souscription?.created_at)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_106, "Signé le " + _toDisplayString(formatDateFrench(member.value.souscription.created_at)), 1))
                : (_openBlock(), _createElementBlock("h5", _hoisted_107, "Signé le -")),
              (member.value.date_engagement)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_108, "Durée: " + _toDisplayString(calculateAnciennete(member.value.date_engagement)), 1))
                : (_openBlock(), _createElementBlock("h6", _hoisted_109, "Durée: -")),
              _cache[36] || (_cache[36] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
              _cache[37] || (_cache[37] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Montant du contrat", -1)),
              (member.value.souscription?.montant)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_110, _toDisplayString(formatAmount(member.value.souscription.montant)) + " F", 1))
                : (_openBlock(), _createElementBlock("h4", _hoisted_111, "-")),
              _cache[38] || (_cache[38] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
              (member.value.actif)
                ? (_openBlock(), _createElementBlock("span", _hoisted_112, "Actif"))
                : (_openBlock(), _createElementBlock("span", _hoisted_113, "Inactif"))
            ]),
            _cache[51] || (_cache[51] = _createElementVNode("div", { class: "flex-center" }, [
              _createElementVNode("hr", { class: "hr-vertical h-100p" })
            ], -1)),
            _createElementVNode("div", _hoisted_114, [
              _createElementVNode("h3", _hoisted_115, [
                _createTextVNode(_toDisplayString(member.value.collectivite?.nom || 'Collectivité') + "   ", 1),
                (member.value.collectivite?.id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_116, "Validé"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_117, "En attente"))
              ]),
              _createElementVNode("h4", _hoisted_118, "Identifiant / " + _toDisplayString(member.value.email || member.value.telephone || 'N/A'), 1),
              (member.value.date_engagement)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_119, [
                    _cache[39] || (_cache[39] = _createTextVNode("Date de début de contrat ", -1)),
                    _cache[40] || (_cache[40] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                    _createElementVNode("b", null, _toDisplayString(formatDateFrench(member.value.date_engagement)), 1)
                  ]))
                : (_openBlock(), _createElementBlock("h6", _hoisted_120, [...(_cache[41] || (_cache[41] = [
                    _createTextVNode("Date de début de contrat ", -1),
                    _createElementVNode("br", { class: "mb-2" }, null, -1),
                    _createElementVNode("b", null, "-", -1)
                  ]))])),
              (member.value.souscription?.date_fin)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_121, [
                    _cache[42] || (_cache[42] = _createTextVNode("Date de fin de contrat ", -1)),
                    _cache[43] || (_cache[43] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                    _createElementVNode("b", null, _toDisplayString(formatDateFrench(member.value.souscription.date_fin)), 1)
                  ]))
                : (_openBlock(), _createElementBlock("h6", _hoisted_122, [...(_cache[44] || (_cache[44] = [
                    _createTextVNode("Date de fin de contrat ", -1),
                    _createElementVNode("br", { class: "mb-2" }, null, -1),
                    _createElementVNode("b", null, "-", -1)
                  ]))]))
            ]),
            _cache[52] || (_cache[52] = _createElementVNode("div", { class: "flex-center" }, [
              _createElementVNode("hr", { class: "hr-vertical h-100p" })
            ], -1)),
            _createElementVNode("div", _hoisted_123, [
              _createElementVNode("h3", _hoisted_124, [
                _cache[45] || (_cache[45] = _createTextVNode(" Membre   ", -1)),
                (member.value.email_verified_at && member.value.actif)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_125, "Validé"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_126, "En attente"))
              ]),
              _createElementVNode("h4", _hoisted_127, "Identifiant / " + _toDisplayString(member.value.email || member.value.telephone || 'N/A'), 1),
              _createElementVNode("h4", _hoisted_128, _toDisplayString(member.value.nom) + " " + _toDisplayString(member.value.prenom), 1),
              (member.value.date_engagement)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_129, [
                    _cache[46] || (_cache[46] = _createTextVNode("Date de début de contrat ", -1)),
                    _cache[47] || (_cache[47] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                    _createElementVNode("b", null, _toDisplayString(formatDateFrench(member.value.date_engagement)), 1)
                  ]))
                : (_openBlock(), _createElementBlock("h6", _hoisted_130, [...(_cache[48] || (_cache[48] = [
                    _createTextVNode("Date de début de contrat ", -1),
                    _createElementVNode("br", { class: "mb-2" }, null, -1),
                    _createElementVNode("b", null, "-", -1)
                  ]))])),
              _cache[49] || (_cache[49] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
              _cache[50] || (_cache[50] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Prélèvement mensuel", -1)),
              (member.value.quotite_cessible_montant)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_131, _toDisplayString(formatAmount(member.value.quotite_cessible_montant)) + " F", 1))
                : (_openBlock(), _createElementBlock("h4", _hoisted_132, "-"))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_133))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_134))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_135))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
          _cache[70] || (_cache[70] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5 collapse-open-flex active" }, [
            _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-panel-open.svg",
                class: "size-xs icon-neutral mr-2 collapse-icon-open",
                alt: ""
              }),
              _createElementVNode("img", {
                src: "/public/icons/icon-panel-close.svg",
                class: "size-xs icon-neutral mr-2 collapse-icon-close",
                alt: ""
              }),
              _createTextVNode(" Premier prélèvement / Carte ")
            ])
          ], -1)),
          _createElementVNode("div", { class: "s10 mt--5-5 flex-right" }, [
            _createElementVNode("button", {
              class: "btn lg py-3 white2 active",
              onClick: goToCarte
            }, [...(_cache[54] || (_cache[54] = [
              _createElementVNode("img", {
                src: "/public/icons/icon-consulter.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Carte", -1)
            ]))])
          ]),
          _cache[71] || (_cache[71] = _createElementVNode("div", { class: "clear-both h-0" }, null, -1)),
          _createElementVNode("div", _hoisted_137, [
            _createElementVNode("div", _hoisted_138, [
              _createElementVNode("h3", _hoisted_139, [
                _cache[55] || (_cache[55] = _createTextVNode(" Premier prélèvement   ", -1)),
                (member.value.souscription_id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_140, "Validé"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_141, "En attente"))
              ]),
              (member.value.souscription_id)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_142, "Signature / CF" + _toDisplayString(member.value.created_at ? _unref(moment)(member.value.created_at).format('YYYY') : '2025') + "-" + _toDisplayString(String(member.value.souscription_id).padStart(6, '0')), 1))
                : (_openBlock(), _createElementBlock("h4", _hoisted_143, "Signature / -")),
              (member.value.souscription?.created_at)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_144, "Effectué le " + _toDisplayString(formatDate(member.value.souscription.created_at, 'DD/MM/YYYY HH:mm')), 1))
                : (_openBlock(), _createElementBlock("h5", _hoisted_145, "-")),
              _cache[56] || (_cache[56] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
              _cache[57] || (_cache[57] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Montant du prélèvement", -1)),
              (member.value.quotite_cessible_montant)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_146, _toDisplayString(formatAmount(member.value.quotite_cessible_montant)) + " F", 1))
                : (_openBlock(), _createElementBlock("h4", _hoisted_147, "-"))
            ]),
            _cache[68] || (_cache[68] = _createElementVNode("div", { class: "flex-center" }, [
              _createElementVNode("hr", { class: "hr-vertical h-100p" })
            ], -1)),
            _createElementVNode("div", _hoisted_148, [
              _createElementVNode("h3", _hoisted_149, [
                _cache[58] || (_cache[58] = _createTextVNode(" Création de la carte   ", -1)),
                (member.value.cartes && member.value.cartes.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_150, "Validé"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_151, "En attente"))
              ]),
              (member.value.cartes && member.value.cartes.length > 0)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_152, "**** **** **** " + _toDisplayString(member.value.cartes[0].bloc4 || (member.value.cartes[0].numero_masque ? member.value.cartes[0].numero_masque.slice(-4) : '****')), 1))
                : (_openBlock(), _createElementBlock("h4", _hoisted_153, "**** **** **** ****")),
              _createElementVNode("h4", _hoisted_154, _toDisplayString(member.value.collectivite?.nom || 'N/A'), 1),
              (member.value.cartes && member.value.cartes[0]?.created_at)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_155, "Créé le " + _toDisplayString(formatDate(member.value.cartes[0].created_at, 'DD/MM/YYYY HH:mm')), 1))
                : (_openBlock(), _createElementBlock("h5", _hoisted_156, "-")),
              _cache[60] || (_cache[60] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
              (member.value.cartes && member.value.cartes[0]?.reference)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_157, "Référence / " + _toDisplayString(member.value.cartes[0].reference), 1))
                : (_openBlock(), _createElementBlock("h4", _hoisted_158, "Référence / -")),
              _cache[61] || (_cache[61] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
              _cache[62] || (_cache[62] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Montant disponible", -1)),
              (member.value.cartes && member.value.cartes[0])
                ? (_openBlock(), _createElementBlock("h4", _hoisted_159, _toDisplayString(formatAmount(member.value.cartes[0].solde || 0)) + " F", 1))
                : (_openBlock(), _createElementBlock("h4", _hoisted_160, "-")),
              (hasCarteEnAttenteRetrait.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 8,
                    class: "btn lg full danger mt-5",
                    style: {"white-space":"nowrap"},
                    onClick: goToCarte
                  }, [...(_cache[59] || (_cache[59] = [
                    _createElementVNode("img", {
                      src: "/public/icons/icon-valider.svg",
                      class: "btn-icon icon-white",
                      alt: ""
                    }, null, -1),
                    _createElementVNode("span", { style: {"color":"var(--color-white)"} }, "Retrait de carte", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ]),
            _cache[69] || (_cache[69] = _createElementVNode("div", { class: "flex-center" }, [
              _createElementVNode("hr", { class: "hr-vertical h-100p" })
            ], -1)),
            _createElementVNode("div", _hoisted_161, [
              _createElementVNode("h3", _hoisted_162, [
                _cache[63] || (_cache[63] = _createTextVNode(" Livraison   ", -1)),
                (member.value.cartes && member.value.cartes[0]?.created_at)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_163, "Validé"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_164, "En attente"))
              ]),
              _cache[65] || (_cache[65] = _createElementVNode("h5", { class: "text-grey-900 my-2" }, "Point relais - collectivité", -1)),
              (member.value.cartes && member.value.cartes[0]?.created_at)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_165, "Livré le " + _toDisplayString(formatDate(member.value.cartes[0].created_at, 'DD/MM/YYYY HH:mm')), 1))
                : (_openBlock(), _createElementBlock("h5", _hoisted_166, "-")),
              _cache[66] || (_cache[66] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
              _createElementVNode("h3", _hoisted_167, [
                _cache[64] || (_cache[64] = _createTextVNode(" Réception   ", -1)),
                (member.value.cartes && member.value.cartes[0]?.date_retrait)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_168, "Validé"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_169, "En attente"))
              ]),
              _cache[67] || (_cache[67] = _createElementVNode("h5", { class: "text-grey-900 my-2" }, "Point relais - collectivité", -1)),
              (member.value.cartes && member.value.cartes[0]?.date_retrait)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_170, "Reçu le " + _toDisplayString(formatDate(member.value.cartes[0].date_retrait, 'DD/MM/YYYY HH:mm')), 1))
                : (_openBlock(), _createElementBlock("h5", _hoisted_171, "Carte non encore retirée"))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_172))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_173))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_174))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
          _cache[79] || (_cache[79] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5 collapse-open active" }, [
            _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-panel-open.svg",
                class: "size-xs icon-neutral mr-2 collapse-icon-open",
                alt: ""
              }),
              _createElementVNode("img", {
                src: "/public/icons/icon-panel-close.svg",
                class: "size-xs icon-neutral mr-2 collapse-icon-close",
                alt: ""
              }),
              _createTextVNode(" Prélèvement mensuel ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_176, [
            _cache[76] || (_cache[76] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
            _createElementVNode("div", _hoisted_177, [
              _createElementVNode("div", _hoisted_178, _toDisplayString(prelevementsStats.value.percent) + "%", 1),
              _createElementVNode("div", {
                class: "h-100p flex align-items-center rounded-100 px-7 bg-pop-green",
                style: _normalizeStyle(`width: ${progressWidth.value}%;`)
              }, [
                _createElementVNode("h2", null, _toDisplayString(formatAmount(prelevementsStats.value.total_effectue)) + " F", 1),
                _createElementVNode("h2", _hoisted_179, " / " + _toDisplayString(formatAmount(prelevementsStats.value.total_attendu)) + " F", 1)
              ], 4)
            ]),
            _cache[77] || (_cache[77] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
            (prelevementsLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_180, " Chargement des prélèvements mensuels... "))
              : (prelevementsMensuels.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_181, " Aucun prélèvement mensuel disponible pour ce membre. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_182, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prelevementsMensuels.value, (detail) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: detail.id,
                        class: _normalizeClass(["widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5", { active: detail.statut === 'done', 'opacity-6': detail.statut === 'cancelled' }])
                      }, [
                        _createElementVNode("div", _hoisted_183, [
                          _createElementVNode("h6", _hoisted_184, _toDisplayString(formatPrelevementDateLong(detail.date_prevision)), 1),
                          _createElementVNode("h3", _hoisted_185, _toDisplayString(formatAmount(detail.montant)) + " F", 1)
                        ]),
                        _createElementVNode("div", _hoisted_186, [
                          (detail.statut === 'pending' && detail.countdown)
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_187, _toDisplayString(detail.countdown), 1))
                            : _createCommentVNode("", true),
                          (detail.statut === 'done')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_188, [...(_cache[72] || (_cache[72] = [
                                _createElementVNode("span", { class: "tag-state notif stroke" }, "Effectué", -1)
                              ]))]))
                            : (detail.statut === 'cancelled')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_189, [...(_cache[73] || (_cache[73] = [
                                  _createElementVNode("span", { class: "tag-state danger stroke" }, "Annulé", -1)
                                ]))]))
                              : _createCommentVNode("", true),
                          (detail.statut === 'done' && detail.date_operation)
                            ? (_openBlock(), _createElementBlock("h6", _hoisted_190, " Le " + _toDisplayString(formatPrelevementDate(detail.date_operation)), 1))
                            : _createCommentVNode("", true),
                          (detail.statut === 'pending')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 4,
                                class: "btn-ultra w-100 shadow-0",
                                disabled: validatingPrelevementId.value !== null,
                                onClick: ($event: any) => (validatePrelevementMensuel(detail))
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["btn-show", { 'display-none': validatingPrelevementId.value === detail.id }])
                                }, [...(_cache[74] || (_cache[74] = [
                                  _createElementVNode("img", {
                                    src: "/public/icons/icon-valider.svg",
                                    class: "btn-icon",
                                    alt: ""
                                  }, null, -1),
                                  _createElementVNode("span", null, "Valider", -1)
                                ]))], 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["btn-loading", { 'display-none': validatingPrelevementId.value !== detail.id }])
                                }, [...(_cache[75] || (_cache[75] = [
                                  _createElementVNode("div", { class: "loader-dots" }, null, -1)
                                ]))], 2)
                              ], 8, _hoisted_191))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    }), 128))
                  ])),
            _cache[78] || (_cache[78] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1))
          ])
        ]))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_192))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_193))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_194))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
          _cache[90] || (_cache[90] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5 collapse-open active" }, [
            _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-panel-open.svg",
                class: "size-xs icon-neutral mr-2 collapse-icon-open",
                alt: ""
              }),
              _createElementVNode("img", {
                src: "/public/icons/icon-panel-close.svg",
                class: "size-xs icon-neutral mr-2 collapse-icon-close",
                alt: ""
              }),
              _createTextVNode(" Décaissement mensuel ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_196, [
            _cache[87] || (_cache[87] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
            _createElementVNode("div", _hoisted_197, [
              _createElementVNode("div", _hoisted_198, [
                _cache[80] || (_cache[80] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                  _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
                  _createTextVNode(" Débloqué ")
                ], -1)),
                _createElementVNode("h1", _hoisted_199, _toDisplayString(formatAmount(decaissementsStats.value.debloque)) + " F", 1),
                _createElementVNode("h5", _hoisted_200, _toDisplayString(decaissementsStats.value.debloque_percent) + "%", 1),
                _createElementVNode("div", _hoisted_201, [
                  _createElementVNode("div", {
                    class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white",
                    style: _normalizeStyle(`width: ${decaissementsStats.value.debloque_percent}%;`)
                  }, _toDisplayString(decaissementsStats.value.debloque_percent) + "% ", 5)
                ])
              ]),
              _createElementVNode("div", _hoisted_202, [
                _cache[81] || (_cache[81] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                  _createElementVNode("div", { class: "circle-medium bg-purple" }),
                  _createTextVNode(" Bloqué ")
                ], -1)),
                _createElementVNode("h1", _hoisted_203, _toDisplayString(formatAmount(decaissementsStats.value.bloque)) + " F", 1),
                _createElementVNode("h5", _hoisted_204, _toDisplayString(decaissementsStats.value.bloque_percent) + "%", 1),
                _createElementVNode("div", _hoisted_205, [
                  _createElementVNode("div", {
                    class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-purple text-white",
                    style: _normalizeStyle(`width: ${decaissementsStats.value.bloque_percent}%;`)
                  }, _toDisplayString(decaissementsStats.value.bloque_percent) + "% ", 5)
                ])
              ]),
              _createElementVNode("div", _hoisted_206, [
                _cache[82] || (_cache[82] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                  _createElementVNode("div", { class: "circle-medium bg-green-light" }),
                  _createTextVNode(" Total ")
                ], -1)),
                _createElementVNode("h1", _hoisted_207, _toDisplayString(formatAmount(decaissementsStats.value.total)) + " F", 1),
                _cache[83] || (_cache[83] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "100%", -1)),
                _cache[84] || (_cache[84] = _createElementVNode("div", {
                  class: "h-40 rounded-100 position-relative overflow-hidden",
                  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
                }, [
                  _createElementVNode("div", {
                    class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
                    style: {"width":"100%"}
                  }, " 100% ")
                ], -1))
              ])
            ]),
            _cache[88] || (_cache[88] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
            (decaissementsLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_208, " Chargement des décaissements mensuels... "))
              : (decaissementsMensuels.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_209, " Aucun décaissement mensuel disponible pour ce membre. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_210, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(decaissementsMensuels.value, (detail) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: detail.id,
                        class: _normalizeClass(["widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5", { active: detail.statut === 'done', 'opacity-6': detail.statut === 'cancelled' }])
                      }, [
                        _createElementVNode("div", _hoisted_211, [
                          _createElementVNode("h6", _hoisted_212, _toDisplayString(formatPrelevementDateLong(detail.date_prevision)), 1),
                          _createElementVNode("h3", _hoisted_213, _toDisplayString(formatAmount(detail.montant)) + " F", 1),
                          _createElementVNode("p", _hoisted_214, _toDisplayString(detail.percent) + "%", 1)
                        ]),
                        _createElementVNode("div", _hoisted_215, [
                          (detail.statut === 'pending' && detail.countdown)
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_216, _toDisplayString(detail.countdown), 1))
                            : _createCommentVNode("", true),
                          (detail.statut === 'done')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_217, [...(_cache[85] || (_cache[85] = [
                                _createElementVNode("span", { class: "tag-state notif stroke" }, "Effectué", -1)
                              ]))]))
                            : (detail.statut === 'cancelled')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_218, [...(_cache[86] || (_cache[86] = [
                                  _createElementVNode("span", { class: "tag-state danger stroke" }, "Annulé", -1)
                                ]))]))
                              : _createCommentVNode("", true),
                          (detail.statut === 'done' && detail.date_operation)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_219, "Date de déblocage"))
                            : _createCommentVNode("", true),
                          (detail.statut === 'done' && detail.date_operation)
                            ? (_openBlock(), _createElementBlock("h6", _hoisted_220, _toDisplayString(formatPrelevementDate(detail.date_operation)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    }), 128))
                  ])),
            _cache[89] || (_cache[89] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1))
          ])
        ]))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_221))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_222))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_223))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
          _cache[95] || (_cache[95] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5 collapse-open active" }, [
            _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-panel-open.svg",
                class: "size-xs icon-neutral mr-2 collapse-icon-open",
                alt: ""
              }),
              _createElementVNode("img", {
                src: "/public/icons/icon-panel-close.svg",
                class: "size-xs icon-neutral mr-2 collapse-icon-close",
                alt: ""
              }),
              _createTextVNode(" Wallet / Utilisation ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_225, [
            _cache[94] || (_cache[94] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
            (walletLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_226, " Chargement du wallet... "))
              : (_openBlock(), _createElementBlock("div", _hoisted_227, [
                  _createElementVNode("div", _hoisted_228, [
                    _cache[91] || (_cache[91] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                      _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
                      _createTextVNode(" Solde ")
                    ], -1)),
                    _createElementVNode("h1", _hoisted_229, _toDisplayString(formatAmount(walletInfos.value.solde)) + " F", 1),
                    _createElementVNode("h5", _hoisted_230, _toDisplayString(walletInfos.value.solde_percent) + "%", 1),
                    _createElementVNode("div", _hoisted_231, [
                      _createElementVNode("div", {
                        class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white",
                        style: _normalizeStyle(`width: ${walletInfos.value.solde_percent}%;`)
                      }, _toDisplayString(walletInfos.value.solde_percent) + "% ", 5)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_232, [
                    _cache[92] || (_cache[92] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                      _createElementVNode("div", { class: "circle-medium bg-purple" }),
                      _createTextVNode(" Montant Utilisé ")
                    ], -1)),
                    _createElementVNode("h1", _hoisted_233, _toDisplayString(formatAmount(walletInfos.value.utilise)) + " F", 1),
                    _createElementVNode("h5", _hoisted_234, _toDisplayString(walletInfos.value.utilise_percent) + "%", 1),
                    _createElementVNode("div", _hoisted_235, [
                      _createElementVNode("div", {
                        class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-purple text-white",
                        style: _normalizeStyle(`width: ${walletInfos.value.utilise_percent}%;`)
                      }, _toDisplayString(walletInfos.value.utilise_percent) + "% ", 5)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_236, [
                    _cache[93] || (_cache[93] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                      _createElementVNode("div", { class: "circle-medium bg-green-light" }),
                      _createTextVNode(" Dernier décaissement ")
                    ], -1)),
                    _createElementVNode("h1", _hoisted_237, _toDisplayString(formatAmount(walletInfos.value.dernier_decaissement)) + " F", 1),
                    _createElementVNode("h5", _hoisted_238, _toDisplayString(walletInfos.value.dernier_decaissement_percent) + "%", 1),
                    _createElementVNode("div", _hoisted_239, [
                      _createElementVNode("div", {
                        class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
                        style: _normalizeStyle(`width: ${walletInfos.value.dernier_decaissement_percent}%;`)
                      }, _toDisplayString(walletInfos.value.dernier_decaissement_percent) + "% ", 5)
                    ])
                  ])
                ]))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})